__turbopack_context__.v({
  "active": "_4NoudW_active",
  "container": "_4NoudW_container",
  "icon": "_4NoudW_icon",
  "playbackRateItem": "_4NoudW_playbackRateItem",
  "playbackRateItemText": "_4NoudW_playbackRateItemText",
  "playbackRatePopper": "_4NoudW_playbackRatePopper",
  "popper": "_4NoudW_popper",
});
